import { useSelector } from 'react-redux';
import { modalIds, params } from '../constants';

const paramConditions = {
  [modalIds.executeDateTime]: 'CanChangeExecuteDate',
  [modalIds.state]: 'CanChangeStatus',
  [modalIds.paymentState]: 'CanChangePaymentState',
  [modalIds.master]: 'CanChangeExecutors',
  [modalIds.executor]: 'CanChangeExecutors',
};

export const useAvailableParams = () => {
  const userInfo = useSelector((store) => store.authentication.userInfo);
  return params.filter(({ id }) => userInfo[paramConditions[id]] ?? true);
};
